.infoBox {
  width: 100%;
  background-color: var(--silver);
  padding: 2em;
  margin-bottom: 2em;

  p {
    margin-bottom: 0;
  }
}

.label {
  flex-basis: 25%;
  text-align: right;
  padding-right: 2em;
}

.info {
  flex-basis: 75%;
}

.row {
  display: flex;
  min-height: 2em;
}

.statusText {
  position: relative;
  display: inline-block;
}

.usagePopUp {
  display: inline-block;
}
